function reFormatPostcodeValue(value) {
  const formattedValue = value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  const spacedPostcode = formattedValue.replace(
    /^([A-Za-z]{1,2}\d{1,2})(\d{1})([A-Za-z]{2})$/,
    "$1 $2$3"
  );
  return spacedPostcode;
}

function dissectAddress(address) {
  const addressSplit = {
    propertyNumberName: "",
    street: "",
  };
  if (address.indexOf(",") >= 0) {
    const values = address.split(",");
    const propertyNumberName = values[0];
    const street = values[1];
    addressSplit.propertyNumberName = propertyNumberName;
    addressSplit.street = street;
  } else {
    const addressPattern = /^(\S+.*?)\s+(.*)$/;
    const match = address.match(addressPattern);
    if (match) {
      addressSplit.propertyNumberName = match[1].trim();
      addressSplit.street = match[2].trim();
    }
  }
  return addressSplit;
}

function resetFormFieldValidation(validationWrapperEL, validationMessageEl) {
  validationWrapperEL.classList.remove("c-validation-message--is-valid");
  validationWrapperEL.classList.remove("c-validation-message--is-invalid");
  validationMessageEl.innerHTML = "";
}

function validateFormField(wrapperEl, messageEl, valid, invalid, message) {
  resetFormFieldValidation(wrapperEl, messageEl);
  if (valid) {
    wrapperEl.classList.add("c-validation-message--is-valid");
  } else if (invalid) {
    wrapperEl.classList.add("c-validation-message--is-invalid");
    messageEl.innerHTML = message;
  }
}

function removeSelectOptions(selectEl) {
  selectEl.innerHTML = "";
}

function initPostcodeLookup(element) {
  const postcodeInput = element.querySelector(".js-water-field");
  const searchButton = element.querySelector(".js-water-search-button");
  const validationWrapperEl = element.querySelector(
    ".js-water-validation-wrapper"
  );
  const validationMessageEl = element.querySelector(
    ".js-water-validation-message"
  );
  const successAddress = element.querySelector(".js-water-success-address");
  const successResult = element.querySelector(".js-results");
  const successResultHeadingEl = element.querySelector(".js-results-heading");
  const successResultBodyEl = element.querySelector(".js-results-body");
  const searchGroup = element.querySelector(".js-search");
  const manualAddress = element.querySelector(".js-water-manual-address");
  const selectAddressLine = element.querySelector(".js-water-select-address");

  const formItems = [];

  function resetPostcodeLookupValidation() {
    if (validationWrapperEl) {
      resetFormFieldValidation(validationWrapperEl, validationMessageEl);
    }
  }

  function resetPostcodeLookup() {
    resetPostcodeLookupValidation();
    if (postcodeInput) {
      postcodeInput.value = "";
    }
  }

  let selectedAddress = {};

  function onSelectAddressConfirm(event, data) {
    const address = dissectAddress(event.target.value);
    const selectedAddressValues = [
      address.propertyNumberName,
      address.street,
      data.townOrCity,
      data.postcode.toUpperCase(),
    ];
    if (formItems) {
      formItems.map((item, index) => {
        const input = item.inputEl;
        input.value = selectedAddressValues[index];
        const newEvent = new Event("change");
        input.dispatchEvent(newEvent);
      });
    }

    selectedAddress = {
      Property: `${address.propertyNumberName} ${address.street}`,
      Town: data.townOrCity,
      Postcode: data.postcode.toUpperCase(),
    };
  }

  function onPostcodeLookupLoading() {
    if (searchButton) {
      searchButton.classList.add("is-loading");
      searchButton.innerHTML = 'Finding address<div class="c-spinner"><div>';
    }
    resetPostcodeLookupValidation();
    if (successAddress) {
      successAddress.classList.add("is-closed");
      successAddress.classList.remove("is-open");
    }
  }

  function onPostcodeLookupFormSuccess(data) {
    searchButton.classList.remove("is-loading");
    searchButton.innerHTML = "Find address";
    validationWrapperEl.classList.add("c-validation-message--is-valid");
    successAddress.classList.remove("is-closed");
    if (selectAddressLine) {
      removeSelectOptions(selectAddressLine);
      selectAddressLine.replaceWith(selectAddressLine.cloneNode(true));
      const newSelectAddressLine = element.querySelector(".js-water-select-address");
    
      newSelectAddressLine.addEventListener("change", (event) => {
        onSelectAddressConfirm(event, data);
    
        try {
          fetch('/ytlapi/propertylookup/geometry', {
            method: "POST",
            body: JSON.stringify(selectedAddress),
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => response.json())
          .then((data) => {
            successResultHeadingEl.innerHTML = data.title;
            successResultBodyEl.innerHTML = data.body;
            searchGroup.classList.remove("js-active");
            successResult.classList.add("js-active");
          });
        } catch (error) {
          console.error("Error:", error);
        }
      });
    
      const placeholderOption = new Option("Please select", "");
      newSelectAddressLine.add(placeholderOption, undefined);
      data.propertyDetails.forEach((address) => {
        const newOption = new Option(
          address.houseNameAndStreet,
          address.houseNameAndStreet
        );
        newSelectAddressLine.add(newOption, undefined);
      });
    }
    
  }

  function onPostcodeLookupFormError() {
    searchButton.classList.remove("is-loading");
    searchButton.innerHTML = "Find address";
    validationWrapperEl.classList.add("c-validation-message--is-invalid");
    validationMessageEl.innerHTML =
      'Sorry! You are not in our supply area.<br>You can use the <a href="https://www.water.org.uk/" target="_blank" rel="noreferrer">Water UK website</a> to find your supplier or <a href="https://www.wessexwater.co.uk/contact-us" target="_blank" rel="noreferrer">contact us</a>.';
  }

  function handlePostcodeLookupFormSubmit(event) {
    event.preventDefault();

    const postcodeValue = event.target.postcode.value
      .toLowerCase()
      .split(" ")
      .join("+");
    onPostcodeLookupLoading();

    fetch(`/ytlapi/propertylookup/postcode?postcode=${postcodeValue}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.propertyDetails.length) {
          onPostcodeLookupFormSuccess(data);
        } else {
          onPostcodeLookupFormError();
        }
      })
      .catch(() => {
        onPostcodeLookupFormError();
      });
  }

  function handleEnterManualAddress() {
    successAddress.classList.remove("is-open");
    successAddress.classList.add("is-closed");
    manualAddress.classList.add("is-open");
    resetPostcodeLookup();
  }

  if (postcodeInput && searchButton) {
    postcodeInput.addEventListener("input", () => {
      const value = postcodeInput.value.trim();
      const reformatedValue = reFormatPostcodeValue(value);
      searchButton.disabled = !reformatedValue;
      postcodeInput.value = reformatedValue;
    });
  }

  const manualButton = element.querySelector(".js-manual-postcode");
  if (manualButton) {
    manualButton.addEventListener("click", (event) => {
      event.preventDefault();
      handleEnterManualAddress();
    });
  }

  const backButton = element.querySelector(".js-back-button");
  if (backButton) {
    backButton.addEventListener("click", () => {
      successResult.classList.remove("js-active");
      searchGroup.classList.add("js-active");
      manualAddress.classList.add("is-closed");
      manualAddress.classList.remove("is-open");
      successAddress.classList.add("is-closed");
      successAddress.classList.remove("is-open");

      resetPostcodeLookup();
    });
  }

  const formGroups = element.querySelectorAll(".js-water-form-group");
  if (formGroups.length) {
    formGroups.forEach((formGroup) => {
      const input = formGroup.querySelector(".c-form-field__input");
      if (input) {
        const inputName = input.name.split("-")[0];
        const formItem = formItems.filter((item) => item.name === inputName)[0];
        if (formItem) {
          formItem.inputEl = input;
          const fgValidationWrapperEl = formGroup.querySelector(
            ".js-validation-wrapper"
          );
          const fgValidationMessageEl = formGroup.querySelector(
            ".js-validation-message"
          );
          if (fgValidationWrapperEl && fgValidationMessageEl) {
            formItem.validationEl = fgValidationWrapperEl;
            formItem.validationMessageEl = fgValidationMessageEl;
            input.addEventListener("change", (event) => {
              const value = event.target.value.trim();
              if (value.length) {
                validateFormField(
                  fgValidationWrapperEl,
                  fgValidationMessageEl,
                  true,
                  false,
                  ""
                );
              } else {
                validateFormField(
                  fgValidationWrapperEl,
                  fgValidationMessageEl,
                  false,
                  true,
                  formItem.validationMessage
                );
              }
            });
            if (inputName === "confirmedPostcode") {
              input.addEventListener("input", (event) => {
                const value = event.target.value.trim();
                event.target.value = reFormatPostcodeValue(value);
              });
            }
          }
        }
      }
    });
  }

  const form = element.querySelector(".js-water-lookup-form");
  if (form) {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      handlePostcodeLookupFormSubmit(event);
    });
  }
}

function init() {
  const elementsWithClass = document.querySelectorAll(".js-water-lookup");

  elementsWithClass.forEach((element) => {
    initPostcodeLookup(element);
  });
}
export default init;



// WEBPACK FOOTER //
// ./src/components/components/wessexwatercorporate/water-meter-tool/water-meter-tool.js